<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Basic Salary"
      text="Create Basic Salary"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="basicSalary"
              v-money="money"
              label="Basic Salary"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="salaryType"
              v-validate="'required'"
              :error-messages="errors.collect('salaryType')"
              :items="salaryTypes"
              data-vv-name="salaryType"     
              data-vv-as="salary type"
              item-text="name"
              item-value="value"
              label="Salary Type"
              outlined
            />
          </v-col>
          
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="effectiveDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('effectiveDateDisplay')"
                  data-vv-name="effectiveDateDisplay"
                  data-vv-as="effective date"
                  label="Effective date"
                  readonly
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                @input="startDateMenu = false"
              />
            </v-menu> 
          </v-col>
        </v-row>
      </v-container> 

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"
          class="px-10 white--text"
          :loading="progressing"
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card> 
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployeeUid: {
        type: String,
        default: null,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        basicSalary: null,
        startDateMenu: false,
        startDate: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        salaryType: null,
        salaryTypes: [
          {
            name: 'Monthly Basis',
            value: 'monthly',
          },
          {
            name: 'Daily Basis',
            value: 'daily',
          },
        ],
      }
    },

    computed: {
      effectiveDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },

    watch: {
      dialog: function (val) {
        if (!val) return this.$resetData()
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            
            this.$api.companyEmployeeSalaries().create(this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })

                this.dialog = false
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return { 
          amount: this.basicSalary.toString().replaceAll(',', ''),
          start_date: this.startDate,
          company_employee_uid: this.companyEmployeeUid,
          salary_type: this.salaryType,
        }
      },
      
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
